import { defineMessages } from 'react-intl'

export default defineMessages({
    banned: {
        id: 'clanmanagement.notifications.banned',
        defaultMessage: 'Действие недоступно. Ваш аккаунт заблокирован.',
    },
    excluded_from_clan: {
        id: 'clanmanagement.notifications.excluded_from_clan',
        defaultMessage: 'Действие недоступно. Вы не состоите в клане.',
    },
    insufficient_permissions: {
        id: 'clanmanagement.notifications.insufficient_permissions',
        defaultMessage: 'Действие недоступно. Недостаточно полномочий.',
    },
    clan_in_transaction: {
        id: 'clanmanagement.notifications.clan_in_transaction',
        defaultMessage: 'Действие недоступно. Ожидайте завершения другого действия с кланом.',
    },
    rank_too_low: {
        id: 'clanmanagement.notifications.rank_too_low',
        defaultMessage: 'Выше вас по должности: {names}',
    },
    treasurers: {
        id: 'clanmanagement.notifications.treasurers',
        defaultMessage: 'Офицеры снабжения: {names}',
    },
    members_not_in_clan: {
        id: 'clanmanagement.notifications.members_not_in_clan',
        defaultMessage: 'Покинули клан: {names}',
    },
    change_commander_cooldown: {
        id: 'clanmanagement.notifications.change_commander_cooldown',
        // eslint-disable-next-line max-len
        defaultMessage: 'Действие недоступно. Вы были недавно назначены командующим. Передать командование вы сможете: {date} {time}',
    },
    remove_members_success_header: {
        id: 'clanmanagement.notifications.remove_members_success_header',
        defaultMessage: 'Исключение из клана',
    },
    remove_members_success_text: {
        id: 'clanmanagement.notifications.remove_members_success_text',
        defaultMessage: 'Следующие игроки исключены из клана: {names}',
    },
    remove_members_server_error: {
        id: 'clanmanagement.notifications.remove_members_server_error',
        defaultMessage: 'Не удалось исключить игроков из клана: ошибка сервера.',
    },
    remove_members_cannot_remove: {
        id: 'clanmanagement.notifications.remove_members_cannot_remove',
        defaultMessage: 'Исключение невозможно',
    },
    change_role_success_header: {
        id: 'clanmanagement.notifications.change_role_success_header',
        defaultMessage: 'Назначение на должность',
    },
    change_role_success_text: {
        id: 'clanmanagement.notifications.change_role_success_text',
        defaultMessage: '{role}: {names}',
    },
    change_role_server_error: {
        id: 'clanmanagement.notifications.change_role_server_error',
        defaultMessage: 'Не удалось изменить должность: ошибка сервера.',
    },
    change_role_cannot_change_role: {
        id: 'clanmanagement.notifications.change_role_cannot_change_role',
        defaultMessage: 'Изменение должности невозможно',
    },
    resource_allocation_success_header: {
        id: 'clanmanagement.notifications.resource_allocation_success_header',
        defaultMessage: 'Распределение казны',
    },
    resource_allocation_gold_success_text: {
        id: 'clanmanagement.notifications.resource_allocation_gold_success_text',
        defaultMessage: 'Распределено золота: {amount}\nЗолото получили: {names}',
    },
    resource_allocation_crystal_success_text: {
        id: 'clanmanagement.notifications.resource_allocation_crystal_success_text',
        defaultMessage: 'Распределено бон: {amount}\nБоны получили: {names}',
    },
    resource_allocation_credits_success_text: {
        id: 'clanmanagement.notifications.resource_allocation_credits_success_text',
        defaultMessage: 'Распределено серебра: {amount}\nСеребро получили: {names}',
    },
    resource_allocation_server_error: {
        id: 'clanmanagement.notifications.resource_allocation_server_error',
        defaultMessage: 'Не удалось распределить казну: ошибка сервера.',
    },
    resource_allocation_error_max_daily_gold_flow: {
        id: 'clanmanagement.notifications.resource_allocation_error_max_daily_gold_flow',
        defaultMessage: 'Превышено ограничение на количество золота ({amount} за {days} д): {names}',
    },
    resource_allocation_error_max_daily_credits_flow: {
        id: 'clanmanagement.notifications.resource_allocation_error_max_daily_credits_flow',
        defaultMessage: 'Превышено ограничение на количество серебра ({amount} за {days} д): {names}',
    },
    resource_allocation_error_max_daily_crystal_flow: {
        id: 'clanmanagement.notifications.resource_allocation_error_max_daily_crystal_flow',
        defaultMessage: 'Превышено ограничение на количество бон ({amount} за {days} д): {names}',
    },
    resource_allocation_error_not_enough_battles: {
        id: 'clanmanagement.notifications.resource_allocation_error_not_enough_battles',
        defaultMessage: 'Не провели необходимое количество боёв на Глобальной карте ({battles} за 28 д): {names}',
    },
    resource_allocation_error_not_in_clan: {
        id: 'clanmanagement.notifications.resource_allocation_error_not_in_clan',
        defaultMessage: 'Покинули клан: {names}',
    },
    resource_allocation_error_permanently_banned: {
        id: 'clanmanagement.notifications.resource_allocation_error_permanently_banned',
        defaultMessage: 'Заблокирован аккаунт: {names}',
    },
    resource_allocation_error_not_enough_resource: {
        id: 'clanmanagement.notifications.resource_allocation_error_not_enough_resource',
        defaultMessage: 'Действие недоступно. В казне недостаточно средств.',
    },
    resource_allocation_cannot_allocate: {
        id: 'clanmanagement.notifications.resource_allocation_cannot_allocate',
        defaultMessage: 'Распределение невозможно',
    },
    change_commander_success_header: {
        id: 'clanmanagement.notifications.change_commander_success_header',
        defaultMessage: 'Передача командования кланом',
    },
    change_commander_success_text: {
        id: 'clanmanagement.notifications.change_commander_success_text',
        defaultMessage: 'Новый командующий: {name}\nВы назначены на должность: {role}',
    },
    change_commander_server_error: {
        id: 'clanmanagement.notifications.change_commander_server_error',
        defaultMessage: 'Не удалось передать командование кланом: ошибка сервера.',
    },
    change_commander_cannot_change_role: {
        id: 'clanmanagement.notifications.change_role_cannot_change_role',
        defaultMessage: 'Изменение должности невозможно',
    },
    change_commander_account_banned: {
        id: 'clanmanagement.notifications.change_commander_account_banned',
        defaultMessage: 'Действие недоступно. Аккаунт игрока {name} заблокирован.',
    },
    change_commander_account_not_in_clan: {
        id: 'clanmanagement.notifications.change_commander_account_not_in_clan',
        defaultMessage: 'Действие недоступно. Игрок {name} покинул клан.',
    },
    too_long_waiting_transaction_status_header: {
        id: 'clanmanagement.notifications.too_long_waiting_transaction_status_header',
        defaultMessage: 'Действие выполняется',
    },
    too_long_waiting_transaction_status: {
        id: 'clanmanagement.notifications.too_long_waiting_transaction_status',
        defaultMessage: 'Другие действия с кланом недоступны: дождитесь завершения текущей операции.',
    },
    change_commander_today: {
        id: 'clanmanagement.notifications.change_commander_today',
        defaultMessage: 'сегодня',
    },
    change_commander_tomorrow: {
        id: 'clanmanagement.notifications.change_commander_tomorrow',
        defaultMessage: 'завтра',
    },
    leave_clan_success_text: {
        id: 'clanmanagement.notifications.leave_clan_success_text',
        defaultMessage: 'Вы покинули клан. Вы сможете вступить в клан через {hours} ч.',
    },
})



// WEBPACK FOOTER //
// ./state/actions/CMT/Notifications/translations.js